<template>
    <div class="summary">
        <alert :type="alertType"
               :dismiss="3000"
               @dismissed="alert = false"
               v-if="alert"
               :show="alert">
            {{ this.alertMessage }}
        </alert>
        <button class="button" @click="$emit('back')"><i class="fas fa-arrow-left"></i>{{ $t('back to the configurator') }}</button>
        <div v-if="loading" class="u-mt--medium u-center">
            <Spinner></Spinner>
            <h2>Wird geladen...</h2>
        </div>
        <div v-if="!loading">
            <div class="grid u-mt--medium">
                <div class="col-7">
                    <div class="table">
                        <div class="table__header">
                            <h2>{{ $t('chosen functions') }}</h2>
                        </div>
                        <div
                            class="table__row"
                            v-for="application in usedApplications"
                            :key="application.id"
                        >
                            {{ application.title }}
                        </div>
                    </div>
                    <div class="card">
                        <div class="card__header">
                            <h2>{{ $t('form title') }}</h2>
                        </div>
                        <div class="card__content">
                            <ul class="advantages title-medium">
                                <li v-for="advantage in $t('summary advantages')" :key="advantage">
                                    {{ advantage }}
                                </li>
                            </ul>
                            <form @submit.prevent="submit" class="u-mt--medium" ref="form">
                                <label>Ihr Name *</label>
                                <input name="name" type="text" placeholder="Ihr Name" class="full" required>
                                <label>E-Mail Adresse *</label>
                                <input name="email" type="email" placeholder="E-Mail Adresse" class="full" required>
                                <label>Name der Schule</label>
                                <input name="name-schule" type="text" placeholder="Name der Schule" class="full">
                                <label>Standort der Schule</label>
                                <input name="standort-schule" type="text" placeholder="Standort der Schule" class="full">
                                <label>Art der Schule</label>
                                <input name="art-schule" type="text" placeholder="Art der Schule" class="full">

                                <label v-if="$route.params.lang == 'de'">Zuständiger Schulträger</label>
                                <input v-if="$route.params.lang == 'de'" type="text" name="schultraeger" placeholder="Zuständiger Schulträger" class="full">
                                <p>* Pflichtfeld</p>
                                <input name="AGB" type="checkbox" required><label>Ich habe die <router-link to="datenschutz" target="_blank">rechtlichen Hinweise und Datenschutz-Richtlinien</router-link> gelesen und akzeptiere diese.</label>
                                <p class="u-right u-mt--small">
                                    <button class="button button--large">
                                        {{ $t('Receive a free summary') }}
                                        <i v-if="isSubmitting" class="fas fa-circle-notch fa-spin"></i>
                                        <i v-else class="fas fa-arrow-right"></i>
                                    </button>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-5 decoration" :style="{'background-image': 'url(' + require('@/assets/user.png') + ')'}">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from '../Spinner'
    import axios from "axios"
    import alert from '../Alert'

    export default {
        components: {
            Spinner,
            alert
        },
        data(){
            return {
                loading: true,
                isSubmitting: false,
                alert: false,
                alertType: "success",
                alertMessage: ""
            }
        },
        props: ['ssid','lisaType'],
        computed: {
            usedTechnologies(){
                return this.$store.getters['configurator/getActiveTechnologies']
            },
            usedApplications() {
                return this.$store.getters['configurator/getActiveApplications']
            }
        },
        mounted(){
            let vm = this
            setTimeout(function(){
                vm.loading = false;
            }, 4000)
        },
        methods: {
            submit(){
                // Locking Mechanism
                if (!this.isSubmitting){
                    let vm = this
                    // Lock
                    this.isSubmitting = true
                    // Create empty data obj
                    let data = {}
                    // Get all selected technologies
                    let activeTechnologies = this.$store.getters['configurator/getActiveApplications']
                    // Append form fields to data obj
                    for(let field of this.$refs["form"].getElementsByTagName("input")){
                        data[field.name] = field.value
                    }
                    // Append static values to data obj
                    data["lang"] = this.$route.params.lang
                    data["technologies"] = activeTechnologies.map(t => parseInt(t.id))
                    data["action"] = "sendPdf"
                    data["fields"] = []

                    for(let field of this.$refs["form"].getElementsByTagName("textarea")){
                        data["fields"].push({name: field.name, value: field.value})
                    }
                    // Append form fields to data obj
                    for(let field of this.$refs["form"].getElementsByTagName("input")){
                        if(field.type == 'checkbox') {
                            data["fields"].push({name: field.name, value: field.checked ? 'Ja' : 'Nein'})
                        } else {
                            data["fields"].push({name: field.name, value: field.value})
                        }
                    }
                    data["uid"] = this.ssid
                    data["lisaType"] = this.lisaType

                    // Send Data
                    axios({
                        method: "POST",
                        url: "https://pdf-degen.education-cloud.eu",
                        data: JSON.stringify(data)
                    }).then((res) => {
                        // Unlock
                        vm.isSubmitting = false
                        // Load next screen
                        if(res.status == 200 && res.data.slice(-2) == "OK"){
                            this.alertType = "success"
                            this.alert = true
                            this.alertMessage = "Vielen Dank! Ihre Konfiguration wurde an unsere Server übermittelt"
                            vm.$emit("next")
                        } else if(res.status == 200) {
                            this.alertType = "error"
                            this.alertMessage = "Es gab ein Problem mit der Erstellung des PDFs, bitte versuchen Sie es erneut."
                            this.alert = true
                        } else {
                            this.alertType = "error"
                            this.alertMessage = "Es gab ein Problem mit dem Server, bitte versuchen Sie es erneut"
                            this.alert = true
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .decoration {
        background-size: contain;
        background-repeat: no-repeat;
    }

    .advantages {
        list-style: none;
        position: relative;
        padding-left: 1.3em;

        li {
            margin-bottom: 15px;
        }

        li::before {
            content:"";
            display: block;
            width: 1em;
            height: 1em;
            position: absolute;
            left: 0px;
            background-image: url('~@/assets/checkmark.png');
            background-size: contain;
            background-repeat: no-repeat;
        }
    }

    @media (max-width:1100px) {
        .col-7 {
            grid-column: span 12;
        }
    }

</style>
